 export default function NotificationsCtrl($scope, notifications) {

  $scope.notifications = notifications.items();

  notifications.remove($scope.$createObservableFunction('remove')
      .debounce(500)
      .filter(function (n) {
        return n.dismiss === true;
      })
      .map(function (n) {
        return n.id;
      })
  );
}
